/**
 * Document Editor Dialog
 * A dialog wrapper for the DocumentEditor component
 */

import React from 'react'
import { Dialog, DialogContent, Slide } from '@mui/material'
import { styled } from '@mui/material/styles'
import DocumentEditor from './DocumentEditor'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: '#1a1a2e',
    maxWidth: '95vw',
    maxHeight: '95vh',
    width: '95vw',
    height: '95vh',
    margin: 0,
    borderRadius: '12px',
    overflow: 'hidden'
  }
}))

const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  '&:first-of-type': {
    paddingTop: 0
  }
})

/**
 * Document Editor Dialog Component
 * 
 * @param {Object} props
 * @param {boolean} props.open - Whether dialog is open
 * @param {function} props.onClose - Called when dialog is closed
 * @param {string} props.imageUrl - URL of the image to edit
 * @param {string} props.imageSrc - Data URL or src of the image to edit
 * @param {function} props.onSave - Called when save button is clicked with { blob, dataUrl, canvas }
 * @param {number} props.initialTab - Initial tab to show (0 = Enhance, 1 = OCR)
 */
export default function DocumentEditorDialog({
  open,
  onClose,
  imageUrl,
  imageSrc,
  onSave,
  initialTab = 0
}) {
  const handleSave = async (result) => {
    if (onSave) {
      await onSave(result)
    }
    onClose?.()
  }

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={false}
    >
      <StyledDialogContent>
        <DocumentEditor
          imageUrl={imageUrl}
          imageSrc={imageSrc}
          onSave={handleSave}
          onClose={onClose}
          initialTab={initialTab}
        />
      </StyledDialogContent>
    </StyledDialog>
  )
}

